import React from 'react';
import BatteryGauge from 'react-battery-gauge'


function BatteryIndicator({value, size}) {
  return (
    <div>
      <BatteryGauge animated size={size || 100} value={value}/>
    </div>
  );
}

export default BatteryIndicator;
